import * as React from 'react';
import { useSelector } from 'react-redux';
import { Button, Chips } from '@cian/ui-kit';
import { FormCardFooterLayout } from '../../../components/RequestFormV2/FormCardFooterLayout';
import { FormCardLayout } from '../../../components/RequestFormV2/FormCardLayout';
import { useAppDispatch } from '../../../hooks/useAppDispatch';
import { selectFlightEnabled } from '../../../selectors/meta';
import { selectQuizItemByType } from '../../../selectors/quizItems';
import { selectFormRoomCount } from '../../../selectors/requestFormV2/selectFormRoomCount';
import { setFormStep, setRoomCount } from '../../../slices/requestFormV2/requestFormV2Slice';
import { TRoomsValue } from '../../../types/quiz';
import { EFormStep } from '../../../types/requestForm/requestFormV2';

export const QuizRoomCount = (): React.JSX.Element | null => {
  const dispatch = useAppDispatch();
  const quizItem = useSelector(selectQuizItemByType('rooms'));
  const roomCountValue = useSelector(selectFormRoomCount);
  const isFlightEnabled = useSelector(selectFlightEnabled);

  const handleChange = (value: TRoomsValue[]) => {
    const calculatedValue = value.length === 0 ? null : value;
    dispatch(setRoomCount(calculatedValue));
  };

  const handleNext = () => {
    dispatch(setFormStep(EFormStep.Prices));
  };

  if (!quizItem) {
    return null;
  }

  return (
    <FormCardLayout
      dataTestId="RequestFormV2RoomCount"
      question={quizItem.title}
      image={quizItem.image}
      imageMobile={quizItem.imageMobile}
      legend={isFlightEnabled ? 'Шаг 1 из 4' : undefined}
    >
      <>
        <Chips
          selectType="multiple"
          value={roomCountValue || undefined}
          onChange={handleChange}
          options={quizItem.options.map(option => ({
            value: option.value,
            label: option.text,
            dataTestId: 'QuizFormChipOption',
          }))}
        />
        <FormCardFooterLayout>
          {roomCountValue && (
            <Button size="M" onClick={handleNext} theme="fill_primary">
              Дальше
            </Button>
          )}
        </FormCardFooterLayout>
      </>
    </FormCardLayout>
  );
};
